<template lang="pug">
  div
    .vendors-subheader.filters-row
      filter-table(
        layout="text"
        @inputSearchFilter="inputSearchFilter")
      ods-button(
        size="medium"
        @click="showVendorsMenu") {{ this.$t('commerceInfo.SellerRegistration') }}
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{prop: 'code', order: 'descending'}"
        )
        ods-table-column(prop='codvends' label='Código Vendedor' sortable)
        ods-table-column(prop='tipdocvs' label='Tipo de Documento' sortable)
        ods-table-column(prop='numdocvs' label='NIF / NIE' sortable)
        ods-table-column(prop='nomvends' label='Nombre' sortable)
        ods-table-column(prop='apellvends' label='Apellidos' sortable)
        ods-table-column(prop='actions' label='Acciones' class-name="cell-actions")
          template(slot-scope="scope")
            ods-actions-menu(
              customClass="card-menu"
              icon="overflow-menu"
              color="#888A91"
              size="18"
              popoverPosition="bottom-end")

              ul.menu
                li.menu__item
                  a(href="#" @click.prevent="goToDetail(scope.row.codvends)")
                    ods-icon(name="eye" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
                    | Ver detalle vendedor
                li.menu__item
                  a(href="#" @click.prevent="goToEdit(scope.row.codvends)")
                    ods-icon(name="pencil" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
                    | Modificar vendedor
                li.menu__item
                  a(href="#" @click.prevent="deleteVendor(scope.row.codvends)" style="color: #DE2F2F")
                    ods-icon(name="delete" color="#DE2F2F" size="24" style="vertical-align: middle").ods-mr-2
                    | Eliminar vendedor

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- ods-pagination.footer__page(
        //- :page-sizes = '[5, 10, 50, 100]',
        //- :page-size = itemsPerPage,
        //- layout='prev, pager, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

    el-drawer(
        :title="vendorTitle"
        :visible.sync="showDetailPage"
        direction="rtl",
        :wrapperClosable="false"
        :append-to-body="false"
        size="60%"
        :class="vendorFormType")
        ods-scrollbar(viewClass="view-class" wrapClass="wrap-class")
          ods-form.vendor-form(
            v-if="formToDisplay === 'vendor'"
            label-position='top'
            :model='vendorFormData'
            ref='ticketForm'
            :rules="formrules"
            :disabled = "vendorFormType === 'show'"
            :show-message="showMessage"
            :validate-on-rule-change="validateOnRuleChange"
            )
            template(v-if="vendorFormType !== 'add'")
              h2.form-section.tp-r-deci {{ this.$t('commerceInfo.dataSeller') }}
              .form-grid
                ods-form-item(label="Código vendedor")
                  ods-input(
                    v-model="vendorFormData.codvends"
                    :disabled="vendorFormType === 'edit'"
                    )
            h2.form-section.tp-r-deci {{ this.$t('commerceInfo.ContactInformation') }}
            .form-grid
              ods-form-item(label="Nombre" prop="nomvends")
                ods-input(v-model="vendorFormData.nomvends" :maxlength="30")
              ods-form-item(label="Apellidos" prop="apellvends" )
                ods-input(v-model="vendorFormData.apellvends" :maxlength="50")
              ods-form-item(label="Tipo documento" prop="tipdocvs")
                ods-input(
                  v-model="vendorFormData.tipdocvs"
                  :disabled="vendorFormType === 'edit'"
                  :maxlength="3"
                  )
              ods-form-item(label="Número documento" prop="numdocvs")
                ods-input(
                  v-model="vendorFormData.numdocvs"
                  :disabled="vendorFormType === 'edit'"
                  :maxlength="12"
                  )
              ods-form-item(label="Teléfono" prop="tlfocomer"
                oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57")
                ods-input(v-model="vendorFormData.tlfocomer" :maxlength="9")
              ods-form-item(label="Correo Electrónico" prop="mailcomer")
                ods-input(v-model="vendorFormData.mailcomer" :maxlength="50")

            h2.form-section.tp-r-deci {{ this.$t('commerceInfo.address') }}
            .form-grid
              //- ods-form-item(label="Tipo de vía")
              //-   ods-input(v-model="vendorFormData.road")
              ods-form-item(label="Dirección" prop="direven" )
                ods-input(v-model="vendorFormData.direven" :maxlength="100")
              ods-form-item(label="Población" prop="poblvend")
                ods-input(v-model="vendorFormData.poblvend" :maxlength="35")
              ods-form-item(label="Código postal" prop="cpvend"
                oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57")
                ods-input(v-model="vendorFormData.cpvend" :maxlength="10")
              ods-form-item(label="Provincia" prop="provvend")
                ods-input(v-model="vendorFormData.provvend" :maxlength="50")

            h2.form-section.tp-r-deci {{ this.$t('commerceInfo.bankData') }}
            .form-grid
              ods-form-item(label="IBAN" prop="iban")
                ods-input(v-model="vendorFormData.iban" :maxlength="4")
              ods-form-item(label="Cuenta de cargo" prop="ctacargo"
                oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57")
                ods-input(v-model="vendorFormData.ctacargo" :maxlength="20")
              ods-form-item(label="Moneda" prop="clamon")
                ods-input(
                  v-model="vendorFormData.clamon"
                  :disabled="vendorFormType === 'edit'"
                  )

            ods-button(@click="addVendor" v-if="vendorFormType === 'add'") {{ this.$t('login.submitButton') }}
            ods-button(@click="modifyVendor" v-if="vendorFormType === 'edit'") {{ this.$t('commerceInfo.modifyData') }}
          ods-button(@click="goToEdit(false)" v-if="vendorFormType === 'show'") {{ this.$t('commerceInfo.editData') }}
</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

import { Utils } from '@/utils/Utils.js'

export default {
  name: 'VendorsTable',

  components: {
    FilterTable,
    Paginator
  },

  props: {
    // data: {
    //   required: true
    // }
  },

  data () {
    var validateNombre = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Campo obligatorio'))
      } else {
        if (Utils.validateCaracEspecial(value)) {
          callback(new Error('Existen caracteres no permitidos'))
        } else {
          callback()
        }
      }
    }
    var validatemailcomer = (rule, value, callback) => {
      if (!Utils.validateEmail(value)) {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    return {
      defaultParams: {
        producto: this.$route.params.comercio.producto,
        subproducto: this.$route.params.comercio.subproducto,
        conprod: this.$route.params.comercio.conprod.toString(),
        codcom: this.$route.params.comercio.codcom
      },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      // tableData: this.data,
      // itemsPerPage: 10,
      // currentPageData: 1,
      // totalData: 0,
      // nuevos
      vendorFormType: 'add',
      vendorTitle: 'Nuevo vendedor',
      showDetailPage: false,
      formToDisplay: 'vendor',
      vendorFormData: {},
      formrules: {
        nomvends: [{ required: true, validator: validateNombre, trigger: 'blur' }],
        apellvends: [{ required: true, validator: validateNombre, trigger: 'blur' }],
        tipdocvs: [{ required: true, validator: validateNombre, trigger: 'blur' }],
        numdocvs: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        tlfocomer: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        mailcomer: [{ required: true, validator: validatemailcomer, trigger: 'blur' }],
        direven: [{ required: true, validator: validateNombre, trigger: 'blur' }],
        poblvend: [{ required: true, validator: validateNombre, trigger: 'blur' }],
        cpvend: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        provvend: [{ required: true, validator: validateNombre, trigger: 'blur' }],
        iban: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        ctacargo: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }]
      },
      showMessage: true,
      validateOnRuleChange: true
    }
  },

  watch: {
    showDetailPage (val) {
      if (this.$refs.ticketForm) {
        this.$refs.ticketForm.clearValidate()
      }
    }
  //   data (newData, oldData) {
  //     this.tableData = newData
  //     this.totalData = newData.length
  //   }
  },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de Vendedores
      await this.$store.dispatch('getVendors', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.apellvends.toLowerCase().includes(text.toLowerCase()) ||
          res.nomvends.toLowerCase().includes(text.toLowerCase()) ||
          res.codvends.toLowerCase().includes(text.toLowerCase()) ||
          res.numdocvs.toString().toLowerCase().includes(text.toLowerCase())
      })
    },

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage
    //     )
    //   }
    // },

    showVendorsMenu () {
      this.formToDisplay = 'vendor'
      this.vendorFormType = 'add'
      this.vendorFormData = {}
      this.showDetailPage = true
      this.vendorTitle = 'Nuevo vendedor'
      // this.$refs.ticketForm.resetFields()
    },

    // vendorSearch (text) {
    //   this.tableDataRendered = this.tableData.filter((res) => {
    //     return res.apellvends.toLowerCase().includes(text.toLowerCase()) ||
    //       res.nomvends.toLowerCase().includes(text.toLowerCase()) ||
    //       res.numdocvs.toLowerCase().includes(text.toLowerCase()) ||
    //       res.codvends.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    addVendor () {
      this.$refs.ticketForm.validate((valid) => {
        if (valid) {
          const today = new Date()
          this.vendorFormData.fecalta = {
            anno: today.getFullYear(),
            dia: today.getDate(),
            format: 'dd-MM-yyyy',
            mes: today.getMonth(),
            nombreDia: '',
            nombreMes: '',
            valueDate: today.getDate() + '-' + today.getMonth() + '-' + today.getFullYear()
          }
          this.vendorFormData.codcom = this.$route.params.comercio.codcom
          this.$store.dispatch('addVendor', this.vendorFormData)
            .then((res) => {
              if (res) {
                if (Array.isArray(res)) {
                  this.$refs.ticketForm.resetFields()
                  this.showDetailPage = false
                  this.dialogMessage = 'Vendedor añadido con éxito'
                  this.message = true
                  this.refreshVendorsList()
                } else {
                  this.errorMsg = res
                }
              }
            })
        } else {
          return false
        }
      })
    },

    refreshVendorsList () {
      this.getInitialData()
      // this.$store.dispatch('getVendors', { codcom: this.commerceData.codcom })
      //   .then((res) => {
      //     this.tableData = res
      //     this.tableDataRendered = this.tableData
      //   })
    },

    goToDetail (numvendor) {
      // this.$emit('goToDetail', numvendor)
      this.vendorFormData = this.tableData.filter((vendor) => vendor.codvends === numvendor)[0]
      this.formToDisplay = 'vendor'
      this.vendorFormType = 'show'
      this.showDetailPage = true
      this.vendorTitle = 'Detalle vendedor'
    },

    goToEdit (numvendor) {
      // this.$emit('goToEdit', numvendor)
      if (numvendor) this.vendorFormData = this.tableData.filter((vendor) => vendor.codvends === numvendor)[0]
      this.formToDisplay = 'vendor'
      this.vendorFormType = 'edit'
      this.showDetailPage = true
      this.vendorTitle = 'Editar vendedor'
    },

    deleteVendor (numvendor) {
      // this.$emit('deleteVendor', numvendor)
      this.showDetailPage = false
      const vendor = this.tableData.filter((vendor) => vendor.codvends === numvendor)[0]
      const today = new Date()
      vendor.fecbaja = {
        anno: today.getFullYear(),
        dia: today.getDate(),
        format: 'dd-MM-yyyy',
        mes: today.getMonth(),
        nombreDia: '',
        nombreMes: '',
        valueDate: today.getDate() + '-' + today.getMonth() + '-' + today.getFullYear()
      }
      const h = this.$createElement
      this.$confirm(h('div', { class: { deletemessage: true } }, [
        h('p', { class: { text: true } }, 'Se va a eliminar el siguiente Vendedor:'),
        h('p', { class: { data: true } }, 'Nº de empleado: ' + vendor.codvends),
        h('p', { class: { data: true } }, 'Nombre: ' + vendor.nomvends),
        h('p', { class: { data: true } }, 'Apellidos: ' + vendor.apellvends),
        h('p', { class: { text: true } }, '¿Está seguro de que desea eliminar de forma permanente este vendedor?')
      ]), 'Warning', {
        title: 'Confirmar eliminación permanente',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('deleteVendor', vendor)
          .then((res) => {
            if (res) {
              this.showDetailPage = false
              this.dialogMessage = 'Vendedor eliminado con éxito'
              this.message = true
              this.refreshVendorsList()
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'eliminación de vendedor cancelada'
        })
      })
    },

    modifyVendor (vendorId) {
      this.$refs.ticketForm.validate((valid) => {
        if (valid) {
          const vendor = this.tableData.filter((vendor) => vendor.codvends === this.vendorFormData.codvends)[0]
          this.vendorFormData.codcom = this.$route.params.comercio.codcom
          this.vendorFormData.contcur = vendor.contcur
          this.showDetailPage = false
          this.$store.dispatch('modifyVendor', this.vendorFormData)
            .then((res) => {
              if (res) {
                this.dialogMessage = 'Vendedor modificado con éxito'
                this.message = true
                this.refreshVendorsList()
              }
            })
        } else {
          return false
        }
      })
    }
  },

  mounted () {
    this.getInitialData()
    // if (Array.isArray(this.data)) this.totalData = this.data.length
    // this.handlePagination()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28);
}

/deep/ .ods-table__row {
  cursor: pointer;
}

/deep/ .ods-table__expanded-cell {
  padding: rem(12) rem(24) !important;
  background: #f9f9fb;
}

/deep/ .ods-table__expanded-cell:hover {
  background-color: #f9f9fb !important;
}

/deep/ .ods-table__expanded-cell:hover td {
  border-bottom: 1px solid #d1d9de;
}

/deep/ .ods-actions-menu__button {
  // width: rem(24);
  // height: rem(24);
}

/deep/ .ods-actions-menu .ods-actions-menu__scroll-area {
  padding: 8px;
}

.tramos {
  .title {
    text-transform: uppercase;
  }

  .ods-table {
    background: #fff;
    margin: 12px 0;
  }

  /deep/ .ods-table thead th {
    padding: 0;
  }

  /deep/ .ods-table td,
  .ods-table th {
    padding: 4px 0;
  }

  /deep/ .ods-table__row--striped > td {
    background: #f0f0f0 !important;
  }
}

.show /deep/ .ods-input.is-disabled .ods-input__inner {
  background-color: transparent;
  border-color: transparent;
  color: black;
  cursor: not-allowed;
  margin-left: 0;
  padding-left: 0;
}

.vendors-subheader {
  display: flex;
  justify-content: space-between;
  // align-items: baseline;
}

.form-grid {
  margin-top: rem(24);
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  column-gap: 48px;
}

.form-section:after {
  content: '';
  height: 1px;
  width: 100%;
  background: #A2ACB3;
  display: block;
  margin-top: rem(8);
}

.ods-form-item {
  line-height: 16px;
}
</style>
